import { useEffect, useRef } from 'react';
import profileService from '../services/profileService';
import { setFromProfile } from './timezoneStore';

/**
 * Pulls the user's zone, the organization default zone, locale and 12h/24h
 * from {@code /api/profile} on mount and pushes them into the global timezone
 * store, which resolves user -> org default -> browser-detected. Re-runs when
 * {@code authVersion} changes so a login picks up the new user's settings
 * without a page refresh.
 *
 * Renders children unchanged — it's a side-effect-only wrapper.
 *
 * Until the API resolves, the store sits on the browser zone with source
 * 'detected' (which is the truth at that moment), so cold-load doesn't flash
 * UTC; a saved/org zone that differs causes one re-render when it arrives.
 */
const TimezoneProvider = ({ children, authVersion }) => {
  const lastVersion = useRef(null);

  useEffect(() => {
    if (lastVersion.current === authVersion) return;
    lastVersion.current = authVersion;
    let cancelled = false;
    const token = localStorage.getItem('authToken');
    if (!token) return; // not logged in — keep browser defaults
    profileService.getProfile()
      .then((data) => {
        if (cancelled) return;
        setFromProfile(data);
      })
      .catch(() => { /* silent — keep browser defaults if API fails */ });
    return () => { cancelled = true; };
  }, [authVersion]);

  return children;
};

export default TimezoneProvider;
